import React from 'react';
import { get } from 'lodash';
import Toggle from '../Toggle';

const ToggleRenderer = ({ dataKey, rowData, columnData: { onChange } = {} }) => {
  const value = get(rowData, dataKey);

  return (
    <Toggle
      value={value}
      onChange={(val, e) => {
        e.stopPropagation();
        onChange({ id: rowData.id, [dataKey]: val });
      }}
    />
  );
};

export default ToggleRenderer;
